import styled from '@emotion/styled';

import { mq } from '@clutter/clean';

export const MobileOnly = styled.span(mq({ display: ['initial', 'none'] }));
export const DesktopOnly = styled.span(mq({ display: ['none', 'inline'] }));
